var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import Field from "./Field.js";
class TextField extends Field {
  construct(config) {
    if ((config == null ? void 0 : config.inputType) === "hidden") {
      config.hidden = true;
    }
    super.construct(...arguments);
  }
}
__publicField(TextField, "$name", "TextField");
__publicField(TextField, "type", "textfield");
__publicField(TextField, "alias", "text");
__publicField(TextField, "configurable", {
  /**
   * The min number of characters for the input field
   * @config {Number} minLength
   * @category Field
   */
  /**
   * The max number of characters for the input field
   * @config {Number} maxLength
   * @category Field
   */
  nullValue: ""
});
TextField.initClass();
TextField._$name = "TextField";
export {
  TextField as default
};
